import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { HeroSection } from './components/HeroSection';
import { ProblemsSection } from './components/ProblemsSection';
import { MethodSection } from './components/MethodSection';
import { IncludesSection } from './components/IncludesSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { AudienceSection } from './components/AudienceSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
export function App() {
  return <div className="min-h-screen bg-[#0A1628] font-sans selection:bg-[#D4AF37] selection:text-black" data-id="element-0">
      <MetaPixel data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemsSection data-id="element-4" />
        <MethodSection data-id="element-5" />
        <IncludesSection data-id="element-6" />
        <BonusesSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <BenefitsSection data-id="element-9" />
        <AudienceSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FinalCTASection data-id="element-13" />
      </main>

      <PurchasePopup data-id="element-14" />

      <footer className="bg-black py-8 text-center border-t border-gray-900" data-id="element-15">
        <p className="text-gray-600 text-sm font-medium" data-id="element-16">
          © {new Date().getFullYear()} Método Detailing Pro. Todos los derechos
          reservados.
        </p>
        <p className="text-gray-700 text-xs mt-2 max-w-2xl mx-auto px-4" data-id="element-17">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}